import styled, { css } from "styled-components";
import InputMask from "react-input-mask";
import Image from "next/image";
import { Button } from "antd";

export const Container = styled.div`
  ${({ theme: { breakpoints } }) => css`
    width: 100%;
    max-width: 1390px;
    margin: 0 auto;
    padding: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 80px;

    @media (max-width: ${breakpoints.smDesktopWidth}) {
      position: relative;
    }

    @media (max-width: ${breakpoints.maxTableWidth}) {
      max-width: 100%;
      padding: 0 40px;
      margin-bottom: 40px;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      width: 100%;
      padding: 0;
    }
  `}
`;

export const BackgroundImageDesktop = styled(Image)`
  ${({ theme: { breakpoints } }) => css`
    width: 800px;
    position: absolute;
    top: 0;
    right: 0;

    @media (max-width: ${breakpoints.smDesktopWidth}) {
      right: -210px;
    }

    @media (max-width: ${breakpoints.maxTableWidth}) {
      display: none;
    }
  `}
`;

export const BackgroundImageTablet = styled(Image)`
  ${({ theme: { breakpoints } }) => css`
    width: 470px;
    position: absolute;
    top: 0;
    right: 0;
    display: none;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      display: block;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      display: none;
    }
  `}
`;

export const BackgroundImageMobile = styled(Image)`
  ${({ theme: { breakpoints } }) => css`
    width: 203px;
    position: absolute;
    top: 0;
    right: 0;
    display: none;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      display: block;
    }
  `}
`;

export const SignWrap = styled.form`
  ${({ theme: { breakpoints, colors } }) => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 280px;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      margin-top: 207px;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      margin-top: 150px;
      border: 1px solid ${colors.lineGray};
      border-radius: 10.5px;
      padding: 20px;
    }
  `}
`;

export const SignTitle = styled.h2`
  ${({ theme: { breakpoints } }) => css`
    font-size: 40px;
    font-weight: 400;
    line-height: 1.3;

    @media (max-width: ${breakpoints.maxTableWidth}) {
      font-size: 32px;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      font-size: 18px;
    }
  `}
`;

export const BrandsWrap = styled.div`
  ${({ theme: { breakpoints } }) => css`
    display: flex;
    justify-content: center;
    gap: 16px;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      display: none;
    }
  `}
`;

export const PhoneInput = styled(InputMask)`
  ${({ theme: { colors, breakpoints } }) => css`
    border-radius: 10.5px;
    border: 1px solid ${colors.lineGray};
    display: flex;
    align-items: center;
    height: 44px;
    width: 283px;
    font-size: 13px;
    padding: 0 16px;
    align-self: center;
    margin-top: 32px;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      width: 334px;
      margin-top: 0;
    }
  `}
`;

export const InputLabel = styled.p`
  ${({ theme: { breakpoints } }) => css`
    font-size: 13px;
    display: none;
    margin-top: 8px;

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      display: flex;
    }
  `}
`;

export const GetSmsBtn = styled(Button)`
  ${({ theme: { colors, breakpoints } }) => css`
    display: flex;
    align-items: center;
    align-self: center;
    justify-content: center;
    height: 44px;
    border-radius: 10.5px;
    background-color: ${colors.black};
    color: ${colors.white};
    text-transform: uppercase;
    font-size: 13px;
    padding: 0 40px;
    width: 283px;
    cursor: pointer;

    &:hover,
    &:focus {
      background-color: ${colors.black} !important;
      color: ${colors.white} !important;
      border: none !important;
    }

    @media (max-width: ${breakpoints.maxMobileWidth}) {
      width: 334px;
    }
  `}
`;

export const FormErrors = styled.p`
  ${({theme: {colors}}) => css`
    font-size: 11px;
    color: ${colors.red};
  `}
`
